window._define('widgets/courseSearch', ['jquery', 'widgets/baseWidget', 'widgets/autocompletefield', 'utils/responsive'], function ($, BaseWidget, Autocomplete) {
    'use strict';

    var widgetName = 'courseSearch',
        jsClassName = 'js-courseSearch';

    // widget definition
    $.widget('OC.' + widgetName, BaseWidget, {
        options: {},

        _create: function () {
            this._super();

            this.elements.$form = $(this.element).find('.js-courseSearch-form');
            this.elements.$input = this.elements.$form.find('.js-courseSearch-input');
            this.elements.$header = this.elements.$form.parents('#oc-header');

            this.onBlurTimeout = null;

            this._on(this.element, {
                'blur .js-courseSearch-input': this._onBlurField,
                'click .js-courseSearch-icon': this._onClickIcon,
            });
        },

        _onSubmit: function (event) {
            clearTimeout(this.onBlurTimeout);
            event.preventDefault();
        },

        _onFocusField: function () {
            this.elements.$header.addClass('has-searchInputFocused');
            this.element.addClass('is-focused');
            this.elements.$input.addClass('is-focused');
        },

        _onClickIcon: function () {
            this._onFocusField();
            this.elements.$input.focus();
        },

        _onBlurField: function () {
            var self = this;

            this.onBlurTimeout = setTimeout(function () {
                self.element.removeClass('is-focused');
                self.elements.$input.removeClass('is-focused');
            }, 200);
        },
    });

    $('.' + jsClassName)[widgetName]();

    return $.OC[widgetName];
});
